import { Flex, HelpTip, TextButton } from "@amzn/storm-ui";

import { INSIGHT_DETAILS_TRIGGER_TEXT } from "../../../../config/insights.config";

export const VisualizationSuccessAction: React.FunctionComponent<{
    executionId: string;
    disabled: boolean;
    handleInsightDetails: () => Promise<void>;
    warning?: boolean;
}> = ({ executionId, disabled, handleInsightDetails, warning }) => {
    return (
        <Flex alignItems="center">
            <TextButton
                data-testid={`${executionId}-insights-sheet-button`}
                disabled={disabled}
                onClick={() => void handleInsightDetails()}
            >
                {INSIGHT_DETAILS_TRIGGER_TEXT}
            </TextButton>
            {warning && (
                <HelpTip id={`${executionId}-visualization-warning`}>
                    Compiled insight genereated with warning, see details for
                    more information
                </HelpTip>
            )}
        </Flex>
    );
};
